import { CompositeDecorator } from 'draft-js';
import { LINK_ENTITY_TYPE } from '../../constants/linkConstants';
import { CHIP_ENTITY_TYPE } from '../../constants/chipConstants';
import ChipDecorator from '../../components/chip/ChipDecorator';
import LinkDecorator from '../../components/link/LinkDecorator';
export var getDecorator = function () { return new CompositeDecorator([
    {
        strategy: findEntitiesByType(CHIP_ENTITY_TYPE),
        component: ChipDecorator,
    },
    {
        strategy: findEntitiesByType(LINK_ENTITY_TYPE),
        component: LinkDecorator,
    },
]); };
var findEntitiesByType = function (type) { return function (contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        return (entityKey !== null &&
            contentState.getEntity(entityKey).getType() === type);
    }, callback);
}; };
//# sourceMappingURL=decorators.js.map